import axios from 'axios';
import urlCfg from '@/config';
import { isWeixinBrowser, isWxMiniProgram, isXlMini } from './judgeEnv';
import { getUrlParam } from './util';

const { baseURL, HOST_BODY } = urlCfg;

export const mapJsSDKConfigUrl = hostbody => {
  if (hostbody.indexOf('huo') !== -1) {
    return `${baseURL}/act/common/mp/jssdk_config`;
  } else {
    // return `${baseURL}/third_app/wechat/welfare_app/jssdk_config`;
    return `${baseURL}/third_app/wechat/xl_subscription_app/jssdk_config`;
  }
};

export const getCoupe = coupeId => {
  const url = `https://coupe-static.xiaolachuxing.com/schema/${coupeId}_data.json`;
  // const url = `https://coupe-static.huolala.cn/schema/${coupeId}_data.json`;
  return new Promise(resolve => {
    try {
      if (!coupeId) {
        resolve({});
        console.log('coupe id为空,默认H5登录');
        return;
      }
      fetch(url, { method: 'GET' })
        .then(res => res.json())
        .then(res => {
          // res即是coupe中的配置信息。
          console.log('coupe中的配置信息' + JSON.stringify(res.data));
          resolve(res.data);
        })
        .catch(res => console.log(res));
    } catch (e) {
      resolve({});
      console.log('coupe数据获取失败' + JSON.stringify(e));
    }
  });
};

function judgeCloseCopyFunc(matchedCb) {
  getCoupe('ff0d16a9ad1744508ef8bb9ce296d2c4').then(x => {
    const pairsStr = (x && x.closeCopyCodeRefPair) || '{}';
    const pairs = JSON.parse(pairsStr);
    const matched =
      Array.isArray(pairs && pairs.pairs) &&
      pairs.pairs.some(x => {
        return x.code === getUrlParam('code') && x.ref === getUrlParam('ref');
      });
    console.log('matched==>', matched);
    if (matched) {
      console.log('---222hide option menu---');
      typeof matchedCb === 'function' && matchedCb();
    }
  });
}

function init() {
  /**微信内分享 **/
  if (isWeixinBrowser() || isWxMiniProgram()) {
    //注入微信分享配置
    axios
      .get(mapJsSDKConfigUrl(HOST_BODY), {
        url: location.href.split('#')[0],
        params: {
          url: location.href.split('#')[0],
          ...(HOST_BODY.indexOf('huo') !== -1
            ? {}
            : {
                appid: 'wxf76bf386d0fdcc0e'
              })
        }
      })
      .then(function(res) {
        let data = res.data.data;
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: [
            'getLocation',
            'closeWindow',
            'onMenuShareAppMessage',
            'onMenuShareTimeline',
            'onMenuShareQQ',
            'onMenuShareQZone',
            'updateAppMessageShareData', //分享到朋友,QQ
            'updateTimelineShareData', //分享到朋友圈,qq空间
            'hideOptionMenu' // hide all
          ],
          openTagList: ['wx-open-launch-weapp']
        });
        wx.ready(function() {
          console.log('wx jssdk ready');
          judgeCloseCopyFunc(() => {
            wx && wx.hideOptionMenu();
          });
        });
      })
      .catch(console.log);
  }
}
init();

// doc:https://developers.weixin.qq.com/community/develop/doc/0008e2f9404cc829ab3bcb64e5e400?_at=1632728995838
const bindEventListener = function(type) {
  const historyEvent = history[type];
  return function() {
    const newEvent = historyEvent.apply(this, arguments);
    const e = new Event(type);
    e.arguments = arguments;
    window.dispatchEvent(e);
    return newEvent;
  };
};
history.pushState = bindEventListener('pushState');
history.replaceState = bindEventListener('replaceState');

window.addEventListener('replaceState', function() {
  console.log('---diy replaceState---');
  init();
});
window.addEventListener('pushState', function() {
  console.log('---diy pushState---');
  init();
});

function wxRegisterShareEvent(title, desc, link, imgUrl, successFn, errFn) {
  console.log(
    { title, desc, link, imgUrl },
    '微信分享title, desc, link, imgUrl'
  );
  wx.ready(function() {
    console.log('wx ready---->');
    // 小程序分享
    if (isWxMiniProgram()) {
      if (isXlMini()) {
        link = `pages/index/index?webview=${encodeURIComponent(link)}`;
      } else {
        link = `pages/home/index?target=adv&targetUrl=${encodeURIComponent(
          link
        )}`;
      }
      wx.miniProgram.postMessage({
        data: {
          shareContent: {
            title: title,
            path: link,
            imageUrl: imgUrl
          }
        }
      });
    }
    // console.log(title)
    //分享到朋友,QQ
    wx.updateAppMessageShareData({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function(res) {
        //alert('已分享给好友');
        // console.log(`success`)
        if (typeof successFn === 'function') {
          successFn(res);
        }
      },
      cancel: function(res) {
        //alert('已取消');
        console.log(`error`, res);
        if (typeof errFn === 'function') {
          errFn(res);
        }
      }
    });
    //分享到朋友圈,qq空间
    wx.updateTimelineShareData({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function(res) {
        // alert('已分享到朋友圈');
        if (typeof successFn === 'function') {
          successFn(res);
        }
      },
      cancel: function(res) {
        // alert('已取消');
        if (typeof errFn === 'function') {
          errFn(res);
        }
      }
    });
    /***
     * 发送给微信好友
     */
    wx.onMenuShareAppMessage({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function(res) {
        if (typeof successFn === 'function') {
          successFn(res);
        }
      },
      cancel: function(res) {
        //alert('已取消');

        if (typeof errFn === 'function') {
          errFn(res);
        }
      }
    });

    /***
     * 分享到朋友圈
     */
    wx.onMenuShareTimeline({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function(res) {
        // alert('已分享到朋友圈');

        if (typeof successFn === 'function') {
          successFn(res);
        }
      },
      cancel: function(res) {
        // alert('已取消');

        if (typeof errFn === 'function') {
          errFn(res);
        }
      }
    });

    /**
     * 分享到QQ
     * */
    wx.onMenuShareQQ({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function() {
        if (typeof successFn === 'function') {
          successFn();
        }
      },
      cancel: function() {
        if (typeof errFn === 'function') {
          errFn();
        }
      }
    });
    /**
     * 分享到QQ空间
     * */
    wx.onMenuShareQZone({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function() {
        if (typeof successFn === 'function') {
          successFn();
        }
      },
      cancel: function() {
        if (typeof errFn === 'function') {
          errFn();
        }
      }
    });

    wx.error(function() {});
  });
}
export default wxRegisterShareEvent;
